import palette from '@lib/core/src/theme/palette';
import { Box, Button, Stack, styled, Typography } from '@mui/material';

import IntegrationBg from '@/assets/backgrounds/integration-bg.png';

export const TemplateCardIconContainer = styled(Box)(() => ({
  borderRadius: '4px',
  background: 'transparent',
  height: '32px',
  width: '32px',
  padding: '8px 10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const AddTemplateButton = styled(Button)(() => ({
  boxShadow: 'none',
  backgroundColor: 'transparent',
  color: palette.grey[500],
  textTransform: 'none',
  padding: '6px 0px 6px 16px',
  '&:hover': {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  }
}));

export const TemplateCardContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  padding: '12px 16px',
  borderRadius: '4px',
  border: `1px solid ${palette.grey[1200]}`,
  backgroundColor: palette.white,
  '&:hover': {
    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%, ${palette.white})`,
    cursor: 'pointer'
  }
}));

export const TemplateConfigItemsTitle = styled(Typography)(() => ({
  fontSize: 11,
  fontWeight: 400,
  color: palette.grey[500],
  marginBottom: '6px'
}));

export const DescrepctionTitle = styled(Typography)(() => ({
  fontSize: 11,
  fontWeight: 600,
  color: palette.grey[500],
  marginTop: '2px'
}));

export const SectionCard = styled(Box)(() => ({
  border: `1px solid ${palette.grey[1200]}`,
  color: palette.black,
  background: palette.white,
  padding: '10px 12px',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: 13
}));

export const SectionCardContainer = styled(Stack)(() => ({
  gap: '6px',
  paddingBottom: '10px'
}));

export const IntegrationBoxContainer = styled(Stack)(() => ({
  border: `1px solid ${palette.grey[1200]}`,
  borderRadius: '8px',
  height: '56px',
  backgroundImage: `url(${IntegrationBg})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  justifyContent: 'space-between',
  flexDirection: 'row',
  alignItems: 'center'
}));

export const IntegrationCard = styled(Box, { shouldForwardProp: prop => prop !== 'isIntegrate' })<{
  isIntegrate: boolean;
}>(({ isIntegrate }) => ({
  border: `1px solid ${palette.grey[1200]}`,
  backgroundColor: isIntegrate ? palette.grey[800] : palette.white,
  borderRadius: '8px',
  color: isIntegrate ? palette.grey[500] : palette.black,
  height: '56px',
  fontSize: '12px',
  padding: '8px 12px',
  minWidth: '150px',
  alignContent: 'center',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: palette.grey[800]
  }
}));

export const AddBlockButton = styled(Button)(() => ({
  boxShadow: 'none',
  backgroundColor: 'transparent',
  color: palette.black,
  textTransform: 'none',
  padding: '6px 0px 6px 16px',
  '&:hover': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    textDecoration: 'underline'
  }
}));
